// import Link from 'next/link';
import { useState } from "react";
import ConnectWalletButton from "../ConnectWalletSection/ConnectWalletButton";
import { Link } from "react-router-dom";

export default function NavBar() {
  const [open, setOpen] = useState(false);
  return (
    <>
      <div className="relative z-[9999]">
        <div className="mx-auto px-4 sm:px-6 bg-transparent">
          <div className="flex justify-between items-center py-6 md:justify-start md:space-x-10">
            <div className="flex justify-start lg:w-0 lg:flex-1">
              <span className="sr-only">Chaos Symphony</span>
              <a href="/" className="my-auto">
                <img
                  src="/3xp-logo/3xpart-logo-color-white.png"
                  alt="3xp"
                  className="cursor-pointer relative h-7 left-2 shadow-lg hover:scale-105 transform transition duration-300 ease-in-out"
                />
              </a>
            </div>
            <div className="-mr-2 -my-2 md:hidden">
              <button
                type="button"
                className="rounded-md p-2 inline-flex items-center justify-center text-white hover:text-gray-500 focus:outline-none focus:ring-2 focus:ring-inset focus:ring-indigo-500"
                onClick={() => setOpen(!open)}
              >
                <span className="sr-only">Open menu</span>
                {/* Heroicon name: outline/menu */}
                <svg
                  className="h-6 w-6"
                  xmlns="http://www.w3.org/2000/svg"
                  fill="none"
                  viewBox="0 0 24 24"
                  stroke="currentColor"
                  aria-hidden="true"
                >
                  <path
                    strokeLinecap="round"
                    strokeLinejoin="round"
                    strokeWidth={2}
                    d="M4 6h16M4 12h16M4 18h16"
                  />
                </svg>
              </button>
            </div>
            <div className="hidden md:flex items-center justify-end md:flex-1 lg:w-0 gap-7">
              <nav className="hidden md:flex space-x-7">
                <Link to="/claim">
                  <button
                    type="button"
                    className="
                     group rounded-md text-white inline-flex items-center text-base font-medium hover:text-gray-500 focus:underline pb-8'
                    "
                  >
                    <span>Claim</span>
                  </button>
                </Link>
                <Link to="/referrals">
                  <button
                    type="button"
                    className="
                     group rounded-md text-white inline-flex items-center text-base font-medium hover:text-gray-500 focus:underline pb-8'
                    "
                  >
                    <span>Referrals</span>
                  </button>
                </Link>
              </nav>
              <ConnectWalletButton />
            </div>
          </div>
        </div>

        <div
          className={
            open
              ? "opacity-100 scale-100 ease-out duration-200 absolute top-0 inset-x-0 p-2 transition transform origin-top-right md:hidden z-[9999]"
              : "opacity-0 scale-95 absolute top-0 inset-x-0 p-2 transition transform origin-top-right md:hidden"
          }
        >
          <div className="rounded-lg shadow-lg ring-1 ring-black ring-opacity-5 bg-white divide-y-2 divide-gray-50 ">
            <div className="pt-5 pb-6 px-5">
              <div className="flex items-center justify-between">
                <div>
                  <a href="/" className="my-auto">
                    <img
                      src="/3xp-logo/3xpart-logo-color-black.png"
                      alt="3xp"
                      className="cursor-pointer relative h-7 left-2 shadow-lg hover:scale-105 transform transition duration-300 ease-in-out"
                    />
                  </a>
                </div>
                <div className="-mr-2">
                  <button
                    type="button"
                    className="bg-white rounded-md p-2 inline-flex items-center justify-center text-black hover:text-gray-500 hover:bg-gray-100 focus:outline-none focus:ring-2 focus:ring-inset focus:ring-indigo-500"
                    onClick={() => setOpen(!open)}
                  >
                    <span className="sr-only">Close menu</span>
                    {/* Heroicon name: outline/x */}
                    <svg
                      className="h-6 w-6"
                      xmlns="http://www.w3.org/2000/svg"
                      fill="none"
                      viewBox="0 0 24 24"
                      stroke="currentColor"
                      aria-hidden="true"
                    >
                      <path
                        strokeLinecap="round"
                        strokeLinejoin="round"
                        strokeWidth={2}
                        d="M6 18L18 6M6 6l12 12"
                      />
                    </svg>
                  </button>
                </div>
              </div>
            </div>
            <div className="py-6 px-5 space-y-6">
              <div className="">
                <div className="flex flex-col gap-3 text-center mb-7">
                  <Link to="/">
                    <button
                      type="button"
                      className="
                      group rounded-md text-black inline-flex items-center text-base font-medium hover:text-gray-500 focus:underline pb-8'
                    "
                    >
                      <span>Home</span>
                    </button>
                  </Link>
                  <Link to="/claim">
                    <button
                      type="button"
                      className="
                      group rounded-md text-black inline-flex items-center text-base font-medium hover:text-gray-500 focus:underline pb-8'
                    "
                    >
                      <span>Claim</span>
                    </button>
                  </Link>
                  <Link to="/referrals">
                    <button
                      type="button"
                      className="
                      group rounded-md text-black inline-flex items-center text-base font-medium hover:text-gray-500 focus:underline pb-8'
                    "
                    >
                      <span>Referrals</span>
                    </button>
                  </Link>
                </div>

                <ConnectWalletButton />
              </div>
            </div>
          </div>
        </div>
      </div>
    </>
  );
}
